import { HTMLAttributes, ReactNode } from "react";
import { Col, Row } from "react-styled-flexboxgrid";
import styled from "styled-components";
import { device } from "../theme/Breakpoints";
import { Color } from "../theme/Color";
import { FontSizes } from "../theme/FontSize";

interface PageSectionProps extends HTMLAttributes<HTMLElement> {
  width?: string;
  fullHeight?: boolean;
  backgroundColor?: Color;
  children: ReactNode;
}

const StyledPageSectionRow = styled(Row)<{
  fullHeight?: boolean;
  backgroundColor?: Color;
  children: ReactNode;
}>`
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? backgroundColor : "none"};
  min-height: ${({ fullHeight }) => (fullHeight ? "100vh" : "auto")};

  & p {
    line-height: 160%;
    margin-bottom: 3rem;
  }
`;

export const StyledSectionHeading = styled(Row)`
  margin: 2rem 0rem;
  font-size: ${FontSizes[4]};
  color: ${Color.Orange5};
  text-transform: uppercase;
  line-height: 150%;
  text-align: center;

  @media ${device.smOnly} {
    margin: 4rem 0rem;
  }

  @media ${device.mdOnly} {
    font-size: ${FontSizes[5]};
    margin: 4rem 0rem;
  }

  @media ${device.lgAndWider} {
    font-size: ${FontSizes[6]};
    margin: 6rem 0rem 8rem 0rem;
  }
`;

const PageSection = ({
  width = "1200px",
  fullHeight = false,
  backgroundColor = Color.White,
  children,
  ...props
}: PageSectionProps) => {
  return (
    <StyledPageSectionRow
      fullHeight={fullHeight}
      backgroundColor={backgroundColor}
      center="xs"
      {...props}
    >
      <Col xs={12} style={{ maxWidth: width ? width : "auto" }}>
        {children}
      </Col>
    </StyledPageSectionRow>
  );
};

export default PageSection;
